import Modal, { ModalProps } from "@timeedit/ui-components/antd/modal/index";
import { useEffect, useRef, useState } from "react";
import Language from "../../lib/Language";
import Input, { InputRef } from "@timeedit/ui-components/antd/input/index";
import { TComponent } from "../../types/utils";

type TNamePromtModalProps = {
    onSaveName: (nameName: string) => void;
    onCancel?: () => void;
    oldName?: string;
    open: boolean;
    title: string;
} & ModalProps;

const NamePromptModal: TComponent<TNamePromtModalProps> = ({
    onSaveName,
    onCancel,
    oldName,
    open,
    title,
}) => {
    const [name, setName] = useState<string>("");
    const nameInputRef = useRef<InputRef>(null);

    useEffect(() => {
        setName(oldName ?? "");
    }, [open]);

    const onOpen = () => {
        if (open) nameInputRef.current?.focus();
    };

    return (
        <Modal
            open={open}
            title={title}
            okText={Language.get("dialog_save")}
            cancelText={Language.get("dialog_cancel")}
            onOk={() => onSaveName(name)}
            okButtonProps={{ disabled: !name }}
            afterOpenChange={onOpen}
            onCancel={onCancel}
        >
            <Input
                ref={nameInputRef}
                autoFocus
                value={name}
                onKeyUp={(e) => {
                    if (e.key === "Enter") {
                        onSaveName(name);
                    }
                    if (e.key === "Escape" && onCancel) {
                        onCancel();
                    }
                }}
                onChange={(e) => {
                    setName(e.target.value);
                }}
            />
        </Modal>
    );
};

export default NamePromptModal;
